import { useTheme, useMediaQuery } from '@mui/material'
import { BasePageContainerProps } from './BasePageContainer'
import { MobilePageContainer } from './MobilePageContainer'
import { DesktopPageContainer } from './DesktopPageContainer'

export const ResponsivePageContainer = (props: BasePageContainerProps) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return isMobile ? (
        <MobilePageContainer {...props} />
    ) : (
        <DesktopPageContainer {...props} />
    )
} 